var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcamSecureLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ecam-logo",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 347 90",
    style: {
      enableBackground: "new 0 0 347 78"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#92908E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    transform: "translate(-184.122 -258.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    transform: "translate(350.589 322.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    className: "st0",
    d: "M5.3,3.4L5.3,3.4L7,8.3H3.7L5.3,3.4z M4.6,1.1l-4,11.1h1.8l0.9-2.5h4.2l0.9,2.5h1.8L6,1.1 L4.6,1.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    transform: "translate(13.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    className: "st0",
    d: "M56.5,1.1l-3,11.1h-2.2l-1.8-5.5l-1.3,4.1L46.8,7l1.8-5.8h1.9L52.2,7l1.4-5.9L56.5,1.1z  M91.7,6.7c0-1.7,0.1-3.2-1.1-4.5c-0.8-0.7-1.9-1.1-3-1.1h-4.1v11.1h4.1c1.1,0,2.2-0.3,3-1.1C91.8,9.9,91.7,8.4,91.7,6.7 M89,6.7 c0,1.9-0.1,2.2-0.3,2.5c-0.3,0.4-0.8,0.7-1.3,0.6h-1.2V3.6h1.2c0.5,0,1,0.2,1.3,0.6C88.9,4.5,89,4.8,89,6.7 M64.8,6.7 c0-1.7,0.1-3.2-1.1-4.4c-1.7-1.7-4.4-1.7-6.1,0c-1.2,1.2-1.1,2.7-1.1,4.4s0,3.2,1.1,4.4c1.7,1.7,4.4,1.7,6.1,0 C64.9,9.9,64.8,8.4,64.8,6.7 M62.1,6.7c0,2-0.1,2.4-0.4,2.7c-0.5,0.6-1.4,0.7-2,0.2c-0.1,0-0.1-0.1-0.2-0.2 c-0.2-0.3-0.4-0.7-0.4-2.7s0.2-2.4,0.4-2.7c0.5-0.6,1.4-0.6,2-0.1c0,0,0.1,0.1,0.1,0.1C62,4.3,62.1,4.7,62.1,6.7 M74.4,12.2 L72,7.6c1.1-0.5,1.8-1.7,1.8-2.9c0-1.9-1.5-3.5-3.5-3.6c-0.1,0-0.2,0-0.3,0h-4.3v11.1h2.7V8.1h0.9l1.9,4.1H74.4z M71.1,4.7 c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0-0.1,0h-1.5V3.6H70C70.6,3.6,71.1,4,71.1,4.7C71.1,4.7,71.1,4.7,71.1,4.7 M82.6,12.2V9.8H78V1.1 h-2.7v11.1L82.6,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    className: "st0",
    d: "M7.9,11.1c-1.7,1.7-4.5,1.7-6.2,0C0.5,9.9,0.6,8.4,0.6,6.7s0-3.2,1.1-4.4 C2.5,1.5,3.6,1,4.7,1.1C6.9,0.9,8.8,2.6,9,4.7H6.3C6.2,4,5.5,3.4,4.7,3.5C4.3,3.5,3.9,3.7,3.7,4C3.4,4.3,3.3,4.7,3.3,6.7 s0.2,2.4,0.4,2.7c0.3,0.3,0.7,0.5,1.1,0.5c0.4,0,0.9-0.1,1.2-0.4c0.3-0.3,0.4-0.8,0.4-1.2V8.1H4.7V5.9H9v1.5 C9,9.2,8.8,10.2,7.9,11.1 M25.5,12.2l-1.9-4.1h-0.9v4.1H20V1.1h4.3c1.9-0.1,3.6,1.4,3.7,3.3c0,0.1,0,0.2,0,0.3 c0,1.2-0.7,2.4-1.8,2.9l2.4,4.6L25.5,12.2z M24.2,3.6h-1.5v2.2h1.5c0.6,0,1.1-0.5,1.2-1.1C25.4,4.1,24.9,3.6,24.2,3.6 C24.2,3.6,24.2,3.6,24.2,3.6 M36.6,11.2c-0.8,0.7-1.9,1.1-3,1.1h-4.1V1.1h4.1c1.1-0.1,2.2,0.3,3,1.1c1.3,1.3,1.1,2.7,1.1,4.5 S37.9,9.9,36.6,11.2 M34.7,4.2c-0.3-0.4-0.8-0.7-1.3-0.6h-1.2v6.2h1.2c0.5,0,1-0.2,1.3-0.6C34.9,8.9,35,8.6,35,6.7 S34.9,4.5,34.7,4.2 M43.8,1.2h-2.1l-4,11.1h2.8l0.5-1.7h2.3l0.6-1.5l1.2,3.2h2.7L43.8,1.2z M41.8,8.3l1-3l0.9,3H41.8z M15.1,1.1 H13L9,12.2h2.8l0.5-1.7h2.3l0.6-1.5l1.2,3.2h2.7L15.1,1.1z M13.1,8.3l1-3l0.9,3H13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    transform: "translate(109.591 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    className: "st0",
    d: "M2.6,3.5C2.8,3.3,3,3.1,3.3,3c0.3-0.2,0.7-0.2,1-0.2c0.5,0,1,0.2,1.4,0.5 C6,3.5,6.3,3.9,6.4,4.3h1.8C8,3.4,7.6,2.6,6.9,2c-0.7-0.6-1.7-1-2.6-1C2.9,1,1.5,1.8,0.8,3C0.6,3.4,0.5,3.7,0.4,4.1 c-0.2,1.7-0.2,3.4,0,5.2c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.1,0.3,0.2,0.5c0.3,0.6,0.8,1,1.3,1.4c0.6,0.4,1.4,0.6,2.2,0.6 c0.9,0,1.8-0.3,2.5-0.8c0.7-0.6,1.2-1.4,1.4-2.4H6.4c-0.3,0.9-1.2,1.5-2.1,1.5c-0.7,0-1.3-0.3-1.7-0.8C2.3,9.6,2.2,9.3,2.1,8.9 C2,8.2,2,7.4,2,6.7C2,6,2,5.2,2.1,4.5C2.2,4.1,2.3,3.8,2.6,3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    className: "st0",
    d: "M17.2,3c-0.3-0.6-0.7-1-1.3-1.4c-0.7-0.4-1.4-0.6-2.2-0.6c-1.4,0-2.8,0.7-3.5,2 C10,3.4,9.9,3.7,9.9,4.1c-0.2,1.7-0.2,3.4,0,5.2c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.1,0.3,0.2,0.5c0.3,0.6,0.8,1,1.3,1.4 c0.6,0.4,1.4,0.6,2.2,0.6c0.8,0,1.6-0.2,2.2-0.6c0.5-0.3,1-0.8,1.3-1.4c0.2-0.3,0.3-0.7,0.4-1.1c0.1-1.7,0.1-3.4,0-5.2 C17.5,3.7,17.4,3.4,17.2,3z M15.9,8.9c-0.1,0.3-0.2,0.7-0.4,0.9c-0.2,0.2-0.4,0.4-0.7,0.6c-0.3,0.2-0.7,0.3-1,0.3 c-0.7,0-1.3-0.3-1.7-0.8c-0.2-0.3-0.4-0.6-0.4-0.9c-0.1-0.7-0.1-1.5-0.1-2.2c0-0.7,0-1.5,0.1-2.2c0.1-0.3,0.2-0.7,0.4-0.9 c0.2-0.2,0.4-0.4,0.7-0.6c0.3-0.2,0.7-0.2,1-0.2c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.3,0.4,0.6,0.4,0.9 C16,5.2,16,5.9,16,6.7C16,7.4,16,8.2,15.9,8.9L15.9,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    className: "st0",
    d: "M58.5,9L58.5,9l-5.1-7.9h-1.6v11.1h1.7V4.4h0l5,7.9h1.6V1.1h-1.7L58.5,9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    className: "st0",
    d: "M44.9,1.1l-4,11.1h1.8l0.9-2.5h4.2l0.9,2.5h1.8l-4-11.1H44.9z M44,8.3l1.6-4.9h0l1.6,4.9H44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    className: "st0",
    d: "M65.8,6.1l2.4-4.9h1.8l-3.3,6.5v4.6h-1.7V7.7l-3.3-6.5h1.8L65.8,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    className: "st0",
    d: "M41.1,3c-0.2-0.4-0.5-0.8-0.9-1.1c-0.4-0.3-0.8-0.5-1.2-0.7c-0.4-0.1-0.8-0.1-1.3-0.1h-4.1 v11.1h1.7V7.9h2.7c1,0,1.9-0.4,2.6-1.1c0.6-0.6,0.9-1.4,0.9-2.2C41.4,4,41.3,3.5,41.1,3z M39.3,5.7c-0.4,0.4-0.9,0.6-1.4,0.6 h-2.6V2.7h2.5c0.4,0,0.8,0.1,1.2,0.3c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.3,0.2,0.6,0.2,0.9C39.7,5,39.6,5.4,39.3,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    className: "st0",
    d: "M25.5,9.6L25.5,9.6l-3.2-8.4h-2.6v11.1h1.7V3.3h0l3.3,8.9h1.4l3.4-8.9h0v8.9h1.7V1.1h-2.7 L25.5,9.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    transform: "translate(184.122 258.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    className: "st1",
    d: "M54.6,16.6L39.5,1.5c-0.4-0.4-1.1-0.4-1.5,0c0,0,0,0,0,0L22.9,16.6 C32.4,9.9,45.1,9.9,54.6,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    className: "st0",
    d: "M16.4,23.1L1.3,38.2c-0.4,0.4-0.4,1.1,0,1.5l15.1,15.1C9.7,45.3,9.7,32.6,16.4,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    className: "st1",
    d: "M22.9,61.3L38,76.4c0.4,0.4,1.1,0.4,1.5,0l15.1-15.1C45.1,68,32.4,68,22.9,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    className: "st0",
    d: "M61,54.8l15.1-15.1c0.4-0.4,0.4-1.1,0-1.5L61,23.1C67.8,32.6,67.8,45.3,61,54.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    transform: "translate(275.262 280.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    className: "st0",
    d: "M0.8,32.2V1.4h19.1v2.9H4.1v10.9h13.5v2.9H4.1v11.1h15.8v2.9L0.8,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    className: "st0",
    d: "M34.2,32.5c-3,0-5.8-1.1-7.9-3.2c-2.9-2.9-2.9-5.9-2.9-12.5s0-9.6,2.9-12.5 c2.1-2.1,4.9-3.2,7.9-3.2c5.5,0,9.7,3.4,10.7,9.2h-3.4c-0.8-3.8-3.5-6.2-7.3-6.2c-2,0-3.9,0.8-5.3,2.2c-1.9,2-2.2,4.1-2.2,10.6 s0.2,8.6,2.2,10.6c1.4,1.4,3.3,2.2,5.3,2.2c3.9,0,6.6-2.5,7.4-6.2h3.3C43.9,29.1,39.7,32.5,34.2,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    className: "st0",
    d: "M68.4,32.2l-2.5-7H52.5l-2.5,7h-3.5L57.9,1.4h2.8l11.3,30.8H68.4z M59.3,6.1l-5.8,16.3H65 L59.3,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    className: "st0",
    d: "M99,32.2V8.8l-8.4,18.6h-2.8L79.2,8.8v23.4h-3.3V1.4h3.3l10,21.9L99,1.4h3.3v30.8L99,32.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    transform: "translate(106.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    className: "st1",
    d: "M19.1,17.7c-1.3-1.1-2.7-1.7-5.6-2.2L10.1,15c-1.5-0.2-2.9-0.8-4.2-1.7 c-1-0.9-1.5-2.2-1.4-3.5C4.6,6.3,7,4,11.1,4c2.7-0.1,5.3,0.8,7.2,2.6l2.1-2.1c-2.5-2.3-5.8-3.6-9.2-3.4c-6.1,0-9.9,3.5-9.9,8.7 c-0.1,2.2,0.7,4.3,2.3,5.8c1.6,1.3,3.6,2.1,5.7,2.3l3.6,0.6c2.3,0.3,3,0.6,4,1.5c1,1,1.6,2.4,1.5,3.9c0,3.6-2.8,5.7-7.3,5.7 c-3.2,0.2-6.2-1.1-8.4-3.4l-2.3,2.3c2.9,2.9,5.9,4.1,10.6,4.1c6.4,0,10.6-3.3,10.6-8.7C21.8,21.4,20.9,19.2,19.1,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    className: "st1",
    d: "M26.6,32.2h19.1v-2.9H29.9V18.2h13.5v-2.9H29.9V4.4h15.8V1.4H26.6V32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    className: "st1",
    d: "M60,4.1c3.9,0,6.5,2.5,7.3,6.2h3.4c-1-5.8-5.2-9.2-10.7-9.2c-3,0-5.8,1.1-7.9,3.2 c-2.9,2.9-2.9,5.9-2.9,12.5s0,9.6,2.9,12.5c2.1,2.1,4.9,3.2,7.9,3.2c5.5,0,9.7-3.4,10.7-9.2h-3.3c-0.8,3.8-3.5,6.2-7.4,6.2 c-2,0-3.9-0.8-5.3-2.2c-1.9-2-2.2-4.1-2.2-10.6s0.2-8.6,2.2-10.6C56.1,4.9,58,4.1,60,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    className: "st1",
    d: "M93.7,21.8c0,4.7-3,7.7-7.5,7.7s-7.4-3.1-7.4-7.7V1.4h-3.3v20.6c0,6.1,4.5,10.4,10.7,10.4 c6.2,0,10.8-4.3,10.8-10.4V1.4h-3.3L93.7,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    className: "st1",
    d: "M117.3,17.9c4-0.6,6.9-4.1,6.7-8.1c0-5.2-3.8-8.4-9.1-8.4H103v30.8h3.3V18.2h7.2l7.2,14.1h3.9 l-7.5-14.3L117.3,17.9z M106.3,4.4h8.2c3.6,0,6.1,1.8,6.1,5.5s-2.6,5.4-6.1,5.4h-8.2V4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    className: "st1",
    d: "M148.4,4.4V1.4h-19.1v30.8h19.1v-2.9h-15.8V18.2h13.5v-2.9h-13.5V4.4H148.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcamSecureLogo);
export default __webpack_public_path__ + "static/media/EcamSecureLogo.c1367349f0ebf1d3504ffa6ab3a11c4a.svg";
export { ForwardRef as ReactComponent };